import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { ReactComponent as CloseIcon } from "../../../../assets/images/x.svg";

function WarningIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64537 18.3024 1.55299 18.6453 1.55201 18.9945C1.55103 19.3437 1.64151 19.6871 1.81445 19.9905C1.98738 20.2939 2.23672 20.5467 2.53771 20.7239C2.83869 20.901 3.18082 20.9962 3.53 21H20.47C20.8192 20.9962 21.1613 20.901 21.4623 20.7239C21.7633 20.5467 22.0126 20.2939 22.1856 19.9905C22.3585 19.6871 22.449 19.3437 22.448 18.9945C22.447 18.6453 22.3546 18.3024 22.18 18L13.71 3.86C13.5317 3.56611 13.2807 3.32312 12.9812 3.15448C12.6817 2.98585 12.3437 2.89725 12 2.89725C11.6563 2.89725 11.3183 2.98585 11.0188 3.15448C10.7193 3.32312 10.4683 3.56611 10.29 3.86Z"
        stroke="#FF4D4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function AgentSuspendModal({ open, agentName, bulkCount = 0, onClose, onConfirm, loading }) {
  const isBulk = bulkCount > 0;
  const displayName = isBulk ? `${bulkCount} agents` : agentName;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(255, 255, 255, 0.6)",
          backdropFilter: "blur(5px)",
          WebkitBackdropFilter: "blur(5px)",
        },
      }}
      PaperProps={{
        sx: {
          width: 408,
          maxWidth: "95vw",
          borderRadius: "12px",
          border: "1px solid #D5DCE1",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          m: 2,
        },
      }}
    >
      <Box sx={{ p: "24px", position: "relative" }}>
        <IconButton onClick={onClose} size="small" sx={{ position: "absolute", top: 16, right: 16, p: 0.5 }}>
          <CloseIcon />
        </IconButton>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "50%",
            bgcolor: "#FFF1F0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <WarningIcon />
        </Box>
        <Typography sx={{ color: "#061522", fontFamily: "Inter", fontSize: 18, fontWeight: 500, mt: 3, mb: 1 }}>
          Suspend Agent{isBulk ? "s" : ""}
        </Typography>
        <Typography sx={{ color: "#556575", fontFamily: "Inter", fontSize: 14, lineHeight: "22px", mb: 3 }}>
          Are you sure you want to suspend{" "}
          <Box component="span" sx={{ color: "#061522", fontWeight: 500 }}>
            {displayName}
          </Box>
          ?
        </Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            onClick={onClose}
            sx={{
              flex: 1,
              height: 40,
              borderRadius: "8px",
              border: "1px solid #D5DCE1",
              background: "#FFF",
              color: "#405261",
              textTransform: "none",
              fontFamily: "Inter",
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={loading}
            onClick={onConfirm}
            sx={{
              flex: 1,
              height: 40,
              borderRadius: "8px",
              background: "#FF4D4F",
              color: "#FFF",
              textTransform: "none",
              fontFamily: "Inter",
              "&:hover": { background: "#E63E40" },
            }}
          >
            Suspend
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
}
